var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.authLoginLoading,
          expression: "authLoginLoading",
        },
      ],
    },
    [
      _c("div", { staticClass: "title" }, [_vm._v("快捷登录授权")]),
      _c("div", { staticClass: "info-box" }, [
        _c("div", { staticClass: "info-label" }, [_vm._v("微信登录")]),
        _c(
          "div",
          { staticClass: "info-content" },
          [
            _c("el-switch", {
              attrs: {
                value: _vm.isAuth,
                "active-color": "#22c655",
                "inactive-color": "#dcdfe6",
                "active-value": true,
                "inactive-value": false,
              },
              on: { change: _vm.switchChange },
            }),
            _c(
              "span",
              {
                staticClass: "info-content-text",
                class: [_vm.isAuth ? "info-content-active" : ""],
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.isAuth ? "已授权" : "未授权") +
                    "\n      "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }